if (process.env.NODE_ENV === 'production') {
  module.exports = require('./style-utils.production.js');
} else {
  module.exports = require('./style-utils.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/style-utils/dist/es/style-utils.js
// module id = 25
// module chunks = 0